import React from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/es';

import enGB from 'antd/lib/locale/en_GB';
import deDE from 'antd/lib/locale/de_DE';
import esES from 'antd/lib/locale/es_ES';

import { ConfigProvider } from 'antd';
import { antdTheme } from 'assets/theme';

dayjs.locale('en');

function getAntdLocale(lang: string) {
  switch (lang.toLowerCase()) {
    case 'de':
      return deDE;
    case 'es':
      return esES;
    default:
      return enGB;
  }
}
const AntdConfigProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const intl = useIntl();
  return (
    <ConfigProvider locale={getAntdLocale(intl.locale)} theme={antdTheme}>
      {children}
    </ConfigProvider>
  );
};

export default AntdConfigProvider;
